module.exports = __webpack_public_path__ + "img/1PNG_Cover.09576ac5.jpg";